"use client"

import { Outlet } from "@remix-run/react"
import { ChevronRight } from "lucide-react"
import * as React from "react"

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "#app/components/ui/collapsible"
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarRail,
  SidebarTrigger,
  SidebarInset,
  SidebarHeader,
} from "#app/components/ui/sidebar"

const data = {
  navMain: [
    {
      title: "Recipes",
      url: "/recipes",
      items: [
        {
          title: "My Recipes",
          url: "/recipes",
        },
        {
          title: "Create Recipe",
          url: "/create-recipe",
        },
        {
          title: "Import Recipe from Text",
          url: "/create-recipe/text",
        },
        {
          title: "Batch Recipe Processing",
          url: "/recipes/batch",
        },
        {
          title: "Recipe Batch Jobs",
          url: "/recipe-jobs",
        },
      ],
    },
    {
      title: "Dishes",
      url: "/dishes",
      items: [
        {
          title: "My Dishes",
          url: "/dishes",
        },
      ],
    },
    {
      title: "Ai Assistant",
      url: "/dashboard",
      items: [
        {
          title: "ChefGpt",
          url: "/dashboard/assistant",
        },
      ],
    },
    {
      title: "Inventory",
      url: "/inventory",
      items: [
        {
          title: "Inventory",
          url: "/inventory",
        },
        {
          title: "Add Inventory",
          url: "/add-inventory",
        },
        {
          title: "Take inventory",
          url: "/inventory/take",
        },
      ],
    },
    {
      title: "Menus",
      url: "/menus",
      items: [
        {
          title: "Menus",
          url: "/menus",
        },
        {
          title: "Create Menu",
          url: "/menus/create",
        },
      ],
    },
    {
      title: "Sales",
      url: "/sales-insights",
      items: [
        {
          title: "Sales insights",
          url: "/sales-insights",
        },
        {
          title: "Upload sales data",
          url: "/upload-sales-data",
        },
      ],
    },
    {
      title: "Analytics",
      url: "/analytics",
      items: [
        {
          title: "Enter Data",
          url: "/analytics",
        },
        {
          title: "Dashboard",
          url: "/analytics/dashboard",
        },
        {
          title: "Saless Analytics",
          url: "/analytics/sales",
        },
        {
          title: "Price Alerts",
          url: "/analytics/price-alerts",
        },
      ],
    },
    {
      title: "Vendors",
      url: "/vendors",
      items: [
        {
          title: "My Vendors",
          url: "/vendors",
        },
        {
          title: "Admin Vendors",
          url: "/admin-vendors",
        },
        {
          title: "Search Vendors",
          url: "/vendors/search",
        },
        {
          title: "Create Vendor",
          url: "/vendors/create",
        },
      ],
    },
    {
      title: "Orders",
      url: "/orders",
      items: [
        {
          title: "My Orders",
          url: "/orders",
        },
        {
          title: "Order Guide",
          url: "/orders/guide",
        },

      ],
    },
    {
      title: "Invoices",
      url: "/invoices",
      items: [
        {
          title: "Batch Invoice Processing",
          url: "/invoices/batch",
        },
        {
          title: "Batch Jobs",
          url: "/invoices/jobs",
        },
        {
          title: "View Invoices",
          url: "/invoices/list",
        },
        {
          title: "CSV Invoices",
          url: "/invoices/csv",
        },
      ],
    },
    {
      title: "Venues",
      url: "/staffing",
      items: [
        {
          title: "Venues",
          url: "/venue",
        },      
      ],
    },
    {
      title: "Employees",
      url: "/employees",
      items: [
        {
          title: "View all employees",
          url: "/employees",
        },
        {
          title: "Add emplotee",
          url: "/employees/create",
        },

      
      ],
    },
    {
      title: "Team",
      url: "/company",
      items: [
        {
          title: "Team Members",
          url: "/company/members",
        },
      ],
    },
    {
      title: "Logout",
      url: "/logout",
      items: [],
    },
  ],
}

export default function Component() {
  // State to manage which collapsible is open
  const [openCollapsible, setOpenCollapsible] = React.useState<string | null>(null)

  // Toggle function
  const toggleCollapsible = (title: string) => {
    setOpenCollapsible((prev) => (prev === title ? null : title))
  }

  return (
    <SidebarProvider>
      <Sidebar className="bg-zinc-900/90 md:bg-transparent">
        <SidebarHeader className="mt-12"></SidebarHeader>
        <SidebarContent className="gap-0 ">
          {/* Create a collapsible SidebarGroup for each parent */}
          {data.navMain.map((item) => (
            <Collapsible
              key={item.title}
              open={openCollapsible === item.title}
              onOpenChange={() => toggleCollapsible(item.title)}
              className="group/collapsible"
            >
              <SidebarGroup>
                <SidebarGroupLabel
                  asChild
                  className="group/label text-sm text-white md:text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground md:hover:bg-sidebar-accent md:hover:text-sidebar-accent-foreground"
                >
                  <CollapsibleTrigger className="w-full text-left flex items-center justify-between">
                    {item.title}{" "}
                    <ChevronRight
                      className={`ml-auto transition-transform ${openCollapsible === item.title ? "rotate-90" : ""}`}
                    />
                  </CollapsibleTrigger>
                </SidebarGroupLabel>
                <CollapsibleContent>
                  <SidebarGroupContent>
                    <SidebarMenu>
                      {item.items.map((subItem) => (
                        <SidebarMenuItem key={subItem.title}>
                          <SidebarMenuButton
                            asChild
                            className="text-white md:text-sidebar-foreground hover:bg-sidebar-accent hover:text-white md:hover:bg-sidebar-accent md:hover:text-sidebar-accent-foreground"
                          >
                            <a href={subItem.url}>{subItem.title}</a>
                          </SidebarMenuButton>
                        </SidebarMenuItem>
                      ))}
                    </SidebarMenu>
                  </SidebarGroupContent>
                </CollapsibleContent>
              </SidebarGroup>
            </Collapsible>
          ))}
        </SidebarContent>
        <SidebarRail />
      </Sidebar>
      <SidebarInset>
        <SidebarTrigger className="-ml-1" />
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
